<template>
  <section>
    <validation-observer ref="sessionForm" #default="{ invalid }">
      <b-form @submit.prevent="sessionForm" v-if="!loading">
        <b-row>
          <b-col cols="12" xl="9" md="8">
            <b-card>
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group
                    label=" * نام جلسه"
                    label-for="add-session-name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="name"
                      vid="name"
                      rules="required"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="add-session-name"
                        v-model="session.name"
                        name="add-session-name"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group
                    label=" * نوع لینک"
                    label-for="add-course-typeLink"
                    class="w-100"
                    rules="required"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="typeLink"
                      vid="typeLink"
                      class="d-flex justify-content-start align-items-center"
                    >
                      <v-select
                        v-model="session.video.type"
                        item-text="label"
                        :options="typeLinks"
                        class="w-100"
                        :reduce="(item) => item.value"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6" v-if="session.video.type">
                  <b-form-group
                    label=" * لینک نمایش"
                    label-for="add-course-video"
                    class="w-100"
                    rules="required"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="video"
                      vid="video"
                      class="d-flex justify-content-start align-items-center"
                    >
                      <select-box
                        v-if="session.video.type == 'kavimo'"
                        v-model="session.video.url"
                        class="w-100"
                        label="title"
                        url="/panel/kavimo/medias"
                        hasSlot
                        searchableSimple
                        searchable
                      >
                        <template #default="{ data }">
                          <div class="d-flex justify-content-between">
                            <!-- <b-img
                              height="40px"
                              width="40px"
                              :src="data.art_files.thumbnail"
                            /> -->
                            {{ data.title }}
                          </div>
                        </template>
                      </select-box>
                      <b-form-input
                        v-else-if="
                          session.video.type == 'aparat' ||
                          session.video.type == 'youtube'
                        "
                        id="link"
                        v-model="session.video.url"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group label-for="add-course-active">
                    <b-form-checkbox
                      v-model="session.active"
                      name="check-active"
                      switch
                      inline
                      :value="1"
                      :unchecked-value="0"
                    >
                      وضعیت جلسه
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>

              <hr class="my-2" />

              <b-row>
                <b-col>
                  <b-form-group label="جزوه" label-for="add-session-pamphlet">
                    <validation-provider
                      #default="{ errors }"
                      name="pamphlet"
                      vid="pamphlet"
                    >
                      <editor
                        v-model="session.pamphlet"
                        :content="session.pamphlet"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group label-for="add-session-pamphlet_file">
                    <validation-provider
                      #default="{ errors }"
                      name="pamphlet_file"
                      vid="pamphlet_file"
                    >
                      <b-form-file
                        browseText="آپلود فایل"
                        placeholder="فایلی انتخاب نشده است"
                        dropPlaceholder="فایل را در این محل رها کنید"
                        id="avatar"
                        v-model="session.pamphlet_file"
                        accept="image/jpeg, image/png, image/gif"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-link v-if="linkFile" :href="linkFile">فایل</b-link>
                </b-col>
              </b-row>
              <hr class="my-2" />
              <b-row>
                <b-col>
                  <faq :faqs="session.faqs" v-model="session.faqs" />
                </b-col>
              </b-row>
              <hr class="my-2" />

              <b-row>
                <b-col>
                  <b-form-group
                    label="توضیحات مختصر"
                    label-for="add-session-brief_description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="brief_description"
                      vid="brief_description"
                    >
                      <editor
                        v-model="session.brief_description"
                        :content="session.brief_description"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr class="my-2" />
              <b-row>
                <b-col>
                  <b-form-group
                    label="توضیحات"
                    label-for="add-session-description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="description"
                      vid="description"
                    >
                      <editor
                        v-model="session.description"
                        :content="session.description"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12" md="4" xl="3" class="invoice-actions mt-md-0 mt-2">
            <b-card>
              <b-form-group
                label="انتخاب بنر برای جلسه"
                label-for="add-session-banner"
              >
                <validation-provider
                  #default="{ errors }"
                  name="banner"
                  vid="banner"
                  class="d-flex justify-content-start align-items-center w-100"
                >
                  <upload-file class="w-100" @uploadImage="uploadImage" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <hr class="my-2" />
              <b-button
                variant="primary"
                class="mb-75"
                block
                :disabled="invalid"
                type="submit"
              >
                {{ $route.params.id ? "ویرایش جلسه" : " ایجاد جلسه" }}
              </b-button>
              <b-button
                variant="outline-primary"
                class="mb-75"
                block
                :to="{ name: 'add-exercise' }"
              >
                ایجاد تمرین
              </b-button>
              <b-button
                :to="{ name: 'sessions' }"
                variant="outline-primary"
                block
              >
                برگشت به لیست جلسات
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <loader :loading="loading" />
  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BBadge,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
  BImg,
  BCard,
  BCardTitle,
  BFormFile,
  BCardText,
  BModal,
  BListGroupItem,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Editor from "@/@core/components/editor/Editor.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import SelectBox from "@/@core/components/select-box/SelectBox.vue";
import UploadFile from "@/@core/components/upload-file/UploadFile.vue";
import draggable from "vuedraggable";
import faq from "@core/components/faq/Faq.vue";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BBadge,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    BFormFile,
    BModal,
    BCard,
    Loader,
    SelectBox,
    Editor,
    UploadFile,
    BListGroupItem,
    draggable,
    faq,
    vSelect,
  },

  data() {
    return {
      session: {
        name: "",
        active: 0,
        type: 1,
        banner: "",
        description: "",
        pamphlet: "",
        pamphlet_file: [],
        video: {
          type: "",
          url: "",
        },
        faqs: [],
      },
      typeLinks: [
        {
          label: "اپارات ",
          value: "aparat",
        },
        {
          label: "یوتوب ",
          value: "youtube",
        },
        {
          label: "کاویمو ",
          value: "kavimo",
        },
        {
          label: "بیگ بلو باتم",
          value: "bbb",
        },
      ],
      linkFile: "",
      loading: false,
      required,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.getSession();
    }
  },
  methods: {
    uploadImage(e) {
      this.session.banner = e;
    },
    async getSession() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `/panel/sessions/${this.$route.params.id}?includes=faqs`
        );
        await Object.keys(data.data).map((item) => {
          item == "active"
            ? (this.session[item] = data.data[item] ? 1 : 0)
            : item == "video"
            ? ((this.session[item].type = data.data[item].type),
              data.data[item].type === "kavimo"
                ? (this.session[item].url = data.data[item].media_id)
                : (this.session[item].url = data.data[item].source))
            : item == "faqs"
            ? (this.session[item] = data.data[item].faqs.map((faq) => {
                return {
                  id: faq.id,
                  active: faq.active ? 1 : 0,
                  question: faq.question,
                  answer: faq.answer,
                };
              }))
            : (this.session[item] = data.data[item]);
          if (item == "pamphlet_file") {
            this.session[item] = [];
            this.linkFile = data.data[item];
          }
        });
      } catch (err) {}
      this.loading = false;
    },
    sessionForm() {
      this.$refs.sessionForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          const session = await { ...this.session };
          try {
            this.formData = await new FormData();
            await Object.keys(session).map((item, index) => {
              if (item == "banner" && session[item] instanceof File === false) {
                session[item] = "";
              }
              if (item == "video" && session[item]) {
                session[item].type == "kavimo"
                  ? (session[item] = {
                      media_id: session[item].url.media_id,
                      type: session[item].type,
                    })
                  : (session[item] = {
                      source: session[item].url,
                      type: session[item].type,
                    });
              }
              if (item == "faqs" && session[item]) {
                session[item] = session[item].map((item) => {
                  return {
                    id: item.id,
                    active: item.active ? 1 : 0,
                    question: item.question,
                    answer: item.answer,
                  };
                });
              }
              this.setFormData(session[item], index, item);
            });
            if (this.$route.params.id) {
              const { data } = await this.$http.post(
                `/panel/sessions/${this.$route.params.id}`,
                this.formData,
                {
                  params: {
                    _method: "put",
                  },
                }
              );
              await this.getSession();
            } else {
              const { data } = await this.$http.post(
                `/panel/sessions`,
                this.formData
              );
              this.session = {
                name: "",
                active: 0,
                type: 1,
                banner: "",
                description: "",
                video: {
                  type: "",
                  url: "",
                },
              };
            }
            this.loading = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: `اطلاعات شما با موفقیت ثبت شد.`,
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              },
              { position: "bottom-right" }
            );
          } catch (err) {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.vpd-input-group {
  .vpd-icon-btn {
    margin-bottom: 0;
  }
  .form-control {
    border-radius: 0;
  }
}
</style>
